export default {
  name: 'editableField',
  globalState: {
    campaign: 'campaignDetails.campaign',
  },
};
